import React, { useState, useEffect, memo } from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { Link } from 'react-router-dom';
import { ServerConfig } from 'config'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../redux/actions/auth.js'

import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';

import BagStickerMap from './BagStickerMap.js'
import NFCTokens from './NFCTokens.js'

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'

import { getAllowedRoutes } from 'utils';
import _, { get } from 'lodash'

const evt = new Event('customertable_is_dirty');

const useStyles = makeStyles((theme) => ({}))

const BagsAndTokens = () => {
  const auth = useSelector(state => state.auth)

  const [value, setValue] = React.useState('1');  // for tabs

  // switch tabs
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
    <TabContext value={value} style={{'marginLeft': '0', 'paddingLeft':'0', 'marginRight': '0', 'paddingRight':'0'}} >
          <TabList onChange={handleChange} aria-label="Subpages">
            <Tab label="Bags" value="1" />
            <Tab label="Tokens" value="2" />
          </TabList>

        <TabPanel value="1" style={{'marginLeft':'0', 'paddingLeft':'0', 'marginRight': '0', 'paddingRight':'0'}} >
          <BagStickerMap />
        </TabPanel>

        <TabPanel value="2" style={{'marginLeft':'0', 'paddingLeft':'0', 'marginRight': '0', 'paddingRight':'0'}} >
          <NFCTokens />
        </TabPanel>
    </TabContext>

    </>
  )
}

export default BagsAndTokens
